<template>
  <v-container class="password-MypageForm-container">
    <v-layout xs12>
      <v-flex>
        <v-text-field
          v-model="password"
          name="password"
          :type="showPassword ? 'text' : 'password'"
          label="パスワード(変更する場合は入力)"
          autocomplete="new-password"
        >
          <template v-slot:append>
            <v-icon
              class="fa-sm"
              style="cursor: pointer;"
              @click="togglePassword"
            >
              {{ showPassword ? "fa-eye" : "fa-eye-slash" }}
            </v-icon>
          </template>
        </v-text-field>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      password: "",
      showPassword: false
    };
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    }
  }
};
</script>

<style lang="scss">
.password-MypageForm {
  &-container {
    padding: 0px !important;
  }
}
</style>
